export default "__VITE_ASSET__BHjVOD2$__"